import type { IValidator } from './IValidator';

export class MonthValidator implements IValidator {
    status: string = '';
    statusType: 'info' | 'warning' | 'error' | 'na' = 'error';
    value?: string;
    validGenderValues: string[] = [];

    public constructor() {}
    Status(): string {
        return this.status;
    }

    StatusType(): 'info' | 'warning' | 'error' | 'na' {
        return this.statusType;
    }

    Value(): string {
        return this.value as string;
    }

    Validate(cellvalue: string): boolean {
        if (Number.isNaN(parseInt(cellvalue))) {
            this.status = 'monthvalidator.unknownmonth';
            this.statusType = 'error';
            return false;
        }
        const month = parseInt(cellvalue);

        if (month < 1 || month > 12) {
            this.status = 'monthvalidator.invalidmonth';
            this.statusType = 'error';
            return false;
        }

        return true;
    }
}
